module.exports = __webpack_public_path__ + "img/boxes-2.44c594de.gif";